import type { SchemaField } from '@cli-types/core-engine/schema.js'
import type { DefaultValueFromTarget } from '@cli-types/next-adapter/forms.js'
import { isLayoutField } from '@core-engine/schema/field-type-guards/is-layout-field.js'
import { buildFieldMap } from './build-field-map.js'

export function collectDefaultValueFromTargets(fields: SchemaField[]): DefaultValueFromTarget[] {
  const fieldMap = buildFieldMap(fields)
  return fields.flatMap((field) => {
    const sourceName = field.defaultValueFrom?.trim()
    if (
      !sourceName ||
      field.primaryKey ||
      field.type === 'tabs' ||
      isLayoutField(field.type) ||
      sourceName === field.name ||
      !fieldMap.has(sourceName)
    ) {
      return []
    }

    return [{ name: field.name, sourceName }]
  })
}
